module.exports = __webpack_public_path__ + "img/smbl.c32a6ce5.png";